module.exports = __webpack_public_path__ + "static/media/tutorial.18d32137.gif";